export const GET_LIST_CAUHINHGOITRAGOP = "GET_LIST_CAUHINHGOITRAGOP";
export const GET_LIST_CAUHINHGOITRAGOP_SUCCESS =
  "GET_LIST_CAUHINHGOITRAGOP_SUCCESS";
export const GET_LIST_CAUHINHGOITRAGOP_FAILURE =
  "GET_LIST_CAUHINHGOITRAGOP_FAILURE";

export const UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP =
  "UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP";
